module.exports = __webpack_public_path__ + "img/vizsgalat.e52f016d.jpg";